<template>
  <div class="flex gap-2">
    <div
      class="max-w-[400px] min-w-[150px] flex items-center relative mx-2 search-wrap"
    >
      <div class="flex items-center absolute h-full search-icon">
        <svg
          class="h-5 leading-9 text-sm text-slate-700 dark:text-slate-200"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.1383 17.1923L9.8575 10.9113C9.3575 11.3241 8.7825 11.6472 8.1325 11.8805C7.4825 12.1138 6.81008 12.2305 6.11525 12.2305C4.40608 12.2305 2.95958 11.6388 1.77575 10.4553C0.591917 9.27175 0 7.82558 0 6.11675C0 4.40808 0.59175 2.96142 1.77525 1.77675C2.95875 0.59225 4.40492 0 6.11375 0C7.82242 0 9.26908 0.591916 10.4537 1.77575C11.6382 2.95958 12.2305 4.40608 12.2305 6.11525C12.2305 6.82942 12.1107 7.5115 11.871 8.1615C11.6312 8.8115 11.3112 9.37683 10.9113 9.8575L17.192 16.1383L16.1383 17.1923ZM6.11525 10.7308C7.40375 10.7308 8.49508 10.2836 9.38925 9.38925C10.2836 8.49508 10.7308 7.40375 10.7308 6.11525C10.7308 4.82675 10.2836 3.73542 9.38925 2.84125C8.49508 1.94692 7.40375 1.49975 6.11525 1.49975C4.82675 1.49975 3.73542 1.94692 2.84125 2.84125C1.94692 3.73542 1.49975 4.82675 1.49975 6.11525C1.49975 7.40375 1.94692 8.49508 2.84125 9.38925C3.73542 10.2836 4.82675 10.7308 6.11525 10.7308Z"
            fill="#6B7280"
            style="
              fill: #6b7280;
              fill: color(display-p3 0.4196 0.4471 0.502);
              fill-opacity: 1;
            "
          />
        </svg>
      </div>
      <input
        type="text"
        :placeholder="$t('AUDIT_LOGS.SEARCH_INPUT_PLACEHOLDER')"
        class="audit-search border-gray-300 dark:border-slate-100 focus:border-green-500"
        :style="searchQuery ? 'box-shadow: inset 0px -1px 2px 0 #3D48571A' : ''"
        :value="searchQuery"
        @keyup.enter="submitSearch"
        @input="inputSearch"
      />
      <button
        v-if="searchQuery"
        class="absolute ltr:right-[72px] rtl:left-[72px] top-[50%] leading-[10px] cursor-pointer"
        style="transform: translateY(-50%)"
        @click="clearSearch"
      >
        <img
          src="~dashboard/assets/images/close.svg"
          class="w-2.5 h-2.5"
          alt=""
        />
      </button>
      <woot-button
        :is-loading="false"
        class="button-naked"
        color-scheme=""
        :class-names="searchButtonClass"
        @click="submitSearch"
      >
        {{ $t('AUDIT_LOGS.SEARCH_BUTTON') }}
      </woot-button>
    </div>
    <div class="relative">
      <div
        v-if="hasAppliedFilters"
        class="absolute h-2 w-2 top-1 right-1 bg-green-500 dark:bg-green-500 rounded-full"
      />
      <div
        data-testid="auditlogs-filter-button"
        class="button-outline flex items-center px-3 py-[7px]"
        @click="toggleFilter"
      >
        <span class="material-symbols-outlined text-[24px]/[24px]">
          filter_alt
        </span>
        <span>{{ $t('AUDIT_LOGS.FILTER') }}</span>
      </div>
    </div>
    <div class="relative">
      <woot-button
        color-scheme=""
        class-names="button-filled"
        :is-loading="uiFlags.isDownloading"
        :disabled="uiFlags.isDownloading"
        @click="exportAuditLogs"
      >
        <span class="flex items-center gap-2">
          <img
            class="w-4 block dark:hidden"
            src="~dashboard/assets/images/export.svg"
            alt="Export"
          />
          {{
            uiFlags.isDownloading
              ? $t('AUDIT_LOGS.EXPORTING')
              : $t('AUDIT_LOGS.EXPORT')
          }}
        </span>
      </woot-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';

export default {
  mixins: [alertMixin],
  data() {
    return {
      searchQuery: '',
    };
  },
  computed: {
    ...mapGetters({
      getAppliedAuditlogsFilters: 'auditlogs/getAppliedAuditlogsFilters',
      getSearchQuery: 'auditlogs/getSearchQuery',
      getExportType: 'auditlogs/getCurrentExportType',
      uiFlags: 'auditlogs/getUIFlags',
    }),
    hasAppliedFilters() {
      return this.getAppliedAuditlogsFilters.length;
    },
    searchButtonClass() {
      return this.searchQuery !== '' ? 'show' : '';
    },
  },
  mounted() {
    this.searchQuery = this.getSearchQuery;
  },
  methods: {
    toggleFilter() {
      this.$root.$emit('openAuditFiltersModal');
    },
    submitSearch() {
      this.$root.$emit('onSubmitSearch');
    },
    clearSearch() {
      this.$store.commit('auditlogs/SET_AUDIT_LOGS_SEARCH_QUERY', '');
      this.searchQuery = '';
      this.$root.$emit('onSubmitSearch');
    },
    inputSearch(e) {
      this.$store.commit(
        'auditlogs/SET_AUDIT_LOGS_SEARCH_QUERY',
        e.target.value
      );
      this.searchQuery = e.target.value;
    },
    async exportAuditLogs() {
      try {
        if (this.getExportType === 'search') {
          await this.$store.dispatch('auditlogs/downloadAuditLogs', {
            queryPayload: {
              payload: { q: this.getSearchQuery },
              export_type: this.getExportType,
            },
          });
        } else {
          const queryPayload =
            this.$store.getters['auditlogs/getCurrentFilterQuery'];

          await this.$store.dispatch('auditlogs/downloadAuditLogs', {
            queryPayload: {
              ...queryPayload,
              export_type: this.getExportType,
            },
          });
        }

        this.showAlert(this.$t('AUDIT_LOGS.EXPORT_SUCCESS'));
      } catch (error) {
        this.showAlert(error?.message || this.$t('AUDIT_LOGS.EXPORT_ERROR'));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~widget/assets/scss/variables';

.search-wrap {
  .audit-search {
    @apply pl-9 pr-[5.75rem] text-sm w-full h-[40px] m-0;
    @apply hover:border-green-500;
  }

  .search-icon {
    @apply left-3;
  }

  .button {
    transition: transform 100ms linear;
    @apply ml-2 h-8 right-1 absolute py-0 px-2 opacity-0 -translate-x-px invisible;
  }

  .button.show {
    @apply opacity-100 translate-x-0 visible;
  }
}

[dir='rtl'] {
  .search-wrap {
    .audit-search {
      @apply pr-9 pl-[5.75rem] text-sm w-full h-[40px] m-0;
    }

    .search-icon {
      @apply right-3;
      left: unset;
    }

    .button {
      transition: transform 100ms linear;
      @apply mr-2 h-8 -left-1 absolute py-0 px-2 opacity-0 -translate-x-px invisible min-w-[63px];
      right: unset;
    }

    .button.show {
      @apply opacity-100 translate-x-0 visible;
    }
  }
}
</style>
